import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n";
import "bootstrap/dist/js/bootstrap.bundle.min";
// ****** Styles ****** //
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { LangContextProvider } from "./context/Context";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
// ****** Styles ****** //
import "./assets/styles/style.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <LangContextProvider>
      <Router>
        <App />
      </Router>
    </LangContextProvider>
  </Provider>
);
